import Receiver from "@mcaptcha/core-glue"

import Hook from "../utils/hook"

export default Hook(`FormCaptcha`, {
  targets: [`iframe`, `input`],

  mounted() {
    const url = this.iframeTarget?.src
    if (!url) return

    this.receiver = new Receiver({ widgetLink: new URL(url) }, (token) => {
      if (this.inputTarget) this.attributeSet(`value`, token, this.inputTarget)
    })

    this.receiver.listen()

    // refresh captcha on form submit (the form is outside the hook root element)
    this.form = this.el.closest(`form`)
    this.formSubmit = this.formSubmit.bind(this)
    this.form?.addEventListener(`submit`, this.formSubmit)
  },

  destroyed() {
    this.receiver?.destroy()
    this.form?.removeEventListener(`submit`, this.formSubmit)
  },

  formSubmit() {
    if (!this.iframeTarget) return
    // eslint-disable-next-line no-self-assign
    this.iframeTarget.src = this.iframeTarget.src
  },
})
